import {createRouter, createWebHistory} from 'vue-router';
// Import das views
import Sobre from '../views/Sobre.vue';
import Projetos from '../views/Projetos.vue';

// Configuração das rotas
const routes = [ 
    { path: '/', component: Sobre },
    { path: '/projetos', component: Projetos }
];

const router = createRouter({
    history: createWebHistory(),
    routes
});

export default router;